import { render } from "./ChatsEntrantesView.vue?vue&type=template&id=12429fee&ts=true"
import script from "./ChatsEntrantesView.vue?vue&type=script&lang=ts"
export * from "./ChatsEntrantesView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__